<template>
  <div class="content block-el">
    <PageHeader :title="$t('customer-component.create-product')">
      <template v-slot:actions>
        <li>
          <a
            v-if="!creating"
            @click="create"
            href="javascript:void(0)"
            class="btn btn-success btn-floating"
          >
            <i
              class="fas fa-save text-white font-size-22 v-align-text-bottom"
            ></i>
          </a>
          <a
            v-else
            href="javascript:void(0)"
            class="btn btn-success btn-floating"
            disabled
          >
            <span class="qt-loader qt-loader-mini qt-loader-right"> </span>
          </a>
        </li>
      </template>
    </PageHeader>
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">{{$t('generic-str.menu.general')}}</div>
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-6">
                  <label for="name">{{$tc('generic-str.name', 1)}}</label>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$tc('generic-str.name', 1)"
                    v-model="form.name"
                  />
                </div>
                <div class="form-group col-6">
                  <label for="name">{{$t('departments.data-infos.lbl-description')}}</label>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('departments.data-infos.lbl-description')"
                    v-model="form.description"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-3">
                  <label for="name">{{$t('generic-str.priority')}}</label>
                  <input
                    type="number"
                    class="form-control"
                    :placeholder="$t('generic-str.priority')"
                    v-model="form.priority"
                  />
                </div>
                <div class="form-group col-3">
                  <label for="name">{{$t('generic-str.cut-percentage')}}</label>
                  <input
                    type="number"
                    class="form-control"
                    :placeholder="$t('generic-str.cut-percentage')"
                    v-model="form.cutting"
                  />
                </div>
                <div class="form-group col-2">
                  <label for="name">{{$t('generic-str.type')}}</label>
                  <select-input
                    v-model="form.type"
                    :options="types"
                    :reduce="(type) => type.value"
                    :clearable="false"
                    @input="changeType"
                  />
                </div>
                <div v-show="form.type != 'live'" class="form-group col-4">
                  <label for="name">{{$tc('generic-str.menu.providers', 1)}}</label>
                  <select-input
                    v-if="providers.length"
                    multiple
                    label="name"
                    :reduce="(provider) => provider.id"
                    v-model="form.providers"
                    :options="providers"
                    :clearable="false"
                  />
                  <div v-else class="preloader pl-xxs pls-primary">
                    <svg class="pl-circular" viewBox="25 25 50 50">
                      <circle class="plc-path" cx="50" cy="50" r="20"></circle>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Tab from '@/directives/Tab';
import PageHeader from '@/components/PageHeader.vue';
import ProductService from '@/services/admin/product.service';
import ProviderService from '@/services/admin/provider.service';
import { mask } from 'vue-the-mask';
import SelectInput from '@/components/SelectInput.vue';

export default {
  name: 'CreateProduct',
  components: {
    PageHeader,
    SelectInput,
  },
  directives: {
    Tab,
    mask,
  },
  data() {
    return {
      fetched: false,
      types: [
        {
          label: 'SMS',
          value: 'sms',
        },
        {
          label: 'EMAIL',
          value: 'email',
        },
        {
          label: 'WHATSAPP',
          value: 'whatsapp',
        },
        {
          label: 'RCS',
          value: 'rcs',
        },
        {
          label: 'Atendimento',
          value: 'live',
        },
      ],
      providers: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 4,
        masked: false,
      },
      customer: {},
      form: {
        name: '',
        description: '',
        priority: 0,
        cutting: 0,
        providers: [],
      },
      creating: false,
      pages: 1,
    };
  },
  created() {
    this.form.type = this.types[0].value;
    this.changeType();
  },
  methods: {
    changeType() {
      this.providers = [];
      this.form.providers = [];
      this.fetchProviders();
    },
    fetchProviders() {
      this.fetched = false;
      const filter = {};
      filter[this.form.type] = true;
      ProviderService.getProviders(filter).then(
        (providers) => {
          this.providers = providers;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    setProvider(provider) {
      this.form.auth = {};
      this.form.type = provider;
      this.form.name = provider;
    },
    ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    create() {
      this.creating = true;
      ProductService.createProduct(this.form)
        .then(
          () => {
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('customer-component.product-created'),
              type: 'success',
            });
            this.$router.push('./');
          },
          (error) => {
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        )
        .finally(() => {
          this.creating = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-cep {
  right: 40px;
  top: 40px;
  position: absolute;
  padding: initial;
}
.preloader {
  margin: unset;
  display: block;
}
</style>
